import React from 'react';

import './WpDropdownMenuDivider.scss';

const WpDropdownMenuDivider = () => {
  return <li className="WpDropdownMenuDivider" />;
};

export default WpDropdownMenuDivider;
